/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Ctl_Friendly_NameInputs */

const en_exp_ctl_friendly_name = /** @type {(inputs: Exp_Ctl_Friendly_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitness`)
};

const de_exp_ctl_friendly_name = /** @type {(inputs: Exp_Ctl_Friendly_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitness`)
};

/**
* | output |
* | --- |
* | "Fitness" |
*
* @param {Exp_Ctl_Friendly_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_ctl_friendly_name = /** @type {((inputs?: Exp_Ctl_Friendly_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Ctl_Friendly_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_ctl_friendly_name(inputs)
	return de_exp_ctl_friendly_name(inputs)
});